module.exports = __webpack_public_path__ + "static/media/consultant.2fec3260.jpg";